"use strict";

var SIGN_IN_MODES = {
  cognito: 'COGNITO',
  google: 'GOOGLE',
  microsoft: 'MICROSOFT'
};
module.exports = SIGN_IN_MODES;